import React from 'react'
import { useSelector } from 'react-redux'
import { Grid, Paper } from '@mui/material'

import { selectFunderProfileCategory, selectFunderProfileInfo } from 'store/selectors/profile'
import SpecialNote from './components/SpecialNote'
import NotEngagedNote from './components/NotEngagedNote'

const DissolvedProfileCard = ({}) => {
  const { name } = useSelector(selectFunderProfileInfo)
  const category = useSelector(selectFunderProfileCategory)

  return (
    <Grid size={{ xs: 12 }}>
      <Paper className={`Full-card gray`}>
        <Grid size={{ xs: 12, lg: 8, xl: 9 }}>
          <h1 className="tw-text-xl">{name}</h1>
          <small className="Full-card__type tw-text-sm">{category}</small>
        </Grid>
      </Paper>
      <SpecialNote />
      <NotEngagedNote />
    </Grid>
  )
}

export default DissolvedProfileCard
